import React, { useRef } from 'react';
import PropTypes         from 'prop-types';
import classNames        from 'classnames';

import Icons             from '../../../assets/svg/icons.js';

import useSelect         from './useSelect';

import styles            from './Select.styl';

function Select(props) {
    const {
        className,
        options,
        placeholder,
        value
    } = props;

    const dropdownRef = useRef()

    const {
        isOpen,
        handleOpen,
        handleChange
    } = useSelect(props, dropdownRef);

    const valueName = options.find(el => el.id === value)?.name;

    return  (
        <div
            className={classNames(styles.Select, {
                [styles.isOpened]: isOpen
            }, className)}
        >
            <div
                className = {styles.valueBlock}
                onClick   = {handleOpen}
            >
                {valueName
                    ? (
                        <div className={styles.value}>
                            {valueName}
                        </div>
                    )
                    : (
                        <div className={styles.placeholder}>
                            {placeholder}
                        </div>
                    )
                }
                <Icons.Chevron
                    className={classNames(styles.chevron, {
                        [styles.openedChevron]: isOpen
                    })}
                />
            </div>
            {isOpen && <div className={styles.valueCover} />}
            {isOpen
                ? (
                    <div
                        className = {styles.dropdownMenu}
                        ref       = {dropdownRef}
                    >
                        {options.map(item => {
                            return (
                                <div
                                    key       = {item.id}
                                    className = {classNames(styles.menuItem, {
                                        [styles.currentItem]: item.id === value
                                    })}
                                    onClick   = {handleChange(item.id)}
                                >
                                    {item.name}
                                </div>
                            )
                        })}
                    </div>
                )
                :null
            }
        </div>
    );
}

Select.propTypes = {
    className   : PropTypes.string,
    options     : PropTypes.array,
    placeholder : PropTypes.string,
    value       : PropTypes.string
};

Select.defaultProps = {
    className   : '',
    options     : [],
    placeholder : '',
    value       : ''
};

export default Select;
